import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { Tramo } from '../data/tramos';
import { SampleLink } from './SampleLink';
type TramoCardProps = {
  tramo: Tramo;
  onBuy: () => void;
};
export function TramoCard({
  tramo,
  onBuy
}: TramoCardProps) {
  return <article className="rounded-2xl border border-line bg-white" data-id="element-169" data-mp="1ix7z9ug3u704">
      <div className="flex flex-col gap-4 px-5 py-5 sm:flex-row sm:items-center sm:gap-6 sm:px-6" data-id="element-170" data-mp="1ivn17uul05xi">
        <div className="flex min-w-0 flex-1 items-start gap-3" data-id="element-171" data-mp="13ymb1vs1gj15">
          <span aria-hidden="true" className={`mt-0.5 h-9 w-9 shrink-0 rounded-lg ${tramo.accent}`} data-id="element-172" data-mp="18zaa94qf866g" />
          <div className="min-w-0" data-id="element-173" data-mp="v00sw1qhb60w">
            <h3 className="font-display text-[19px] font-bold uppercase leading-tight text-ink" data-id="element-174" data-mp="v13kyczjfeie">
              {tramo.name} · {tramo.level}
            </h3>
            <p className="mt-1 font-sans text-[15px] text-ink-soft" data-id="element-175" data-mp="2pd0jepwedkmy">
              {tramo.summary}
            </p>
            <span className="mt-3 inline-flex items-center gap-2 rounded-full bg-sage px-3 py-1.5 font-sans text-[13px] font-bold uppercase tracking-[0.04em] text-[#3F6349]" data-id="element-176" data-mp="2ub20x6e6dbwb">
              <span aria-hidden="true" className="h-2 w-2 rounded-full bg-[#4B7A58]" data-id="element-177" data-mp="hjqeasbn94p2" />
              Ahorrás {tramo.savings}
            </span>
          </div>
        </div>

        <div className="flex shrink-0 flex-col items-start gap-3 sm:items-end" data-id="element-178" data-mp="qbinz0sug9sl">
          <div className="flex items-baseline gap-2 sm:flex-col sm:items-end sm:gap-0" data-id="element-179" data-mp="qdlncbfvzf9z">
            <p className="font-sans text-[15px] text-muted line-through" data-id="element-180" data-mp="2m7w68th1pql">
              {tramo.original}
            </p>
            <p className="font-display text-[32px] font-semibold leading-none text-coral" data-id="element-181" data-mp="3us3cogbp3xgq">
              {tramo.price}
              <span className="ml-1 font-sans text-[13px] font-normal text-muted" data-id="element-182" data-mp="7laocsocs1h5">
                UY
              </span>
            </p>
          </div>
          <button type="button" onClick={onBuy} className="inline-flex min-h-[48px] items-center gap-2 rounded-full bg-coral px-6 font-sans text-[15px] font-bold text-white transition-[transform,background-color] duration-150 ease-out hover:bg-[#8E5231] focus:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-2 active:scale-[0.98]" data-id="element-183" data-mp="1nxfzufcpxgvk">
            Lo quiero ahora!
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-184" data-mp="202d9wpf8dur9" />
          </button>
          <SampleLink variant="inline" data-id="element-185" data-mp="24zbzcuny9dj4" />
        </div>
      </div>
    </article>;
}